export default "__VITE_ASSET__CDLDE1Ds__"